<template>
  <component :is="$route.meta.layout" v-if="$route.meta.layout">
    <router-view />
  </component>
</template>
<script>
export default {
  mounted(){
    // console.log(this.$route);
  }
};
</script>
